import React, { useState } from 'react'

import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'
import { DocumentLabel } from '@app/lib/components/DocumentLabel'
import { DownloadAllDocumentsButton } from '@app/modules/ClientsProfile/DownloadAllDocumentsButton/DownloadAllDocumentsButton'
import { useMobile } from '@app/services/useMobile'

import { useCourtCaseContext } from '../CourtCaseContext/CourtCaseContext'

import './styles.scss'

export const CourtCaseDocuments = () => {
  const { formatMessage } = useIntl()
  const b = bemJoin('court-case-documents')
  const { isMobile } = useMobile()
  const { data: courtCaseData } = useCourtCaseContext()
  const documents = courtCaseData?.documents
  const [showAllDocuments, setShowAllDocuments] = useState(false)

  if (!documents || documents.length === 0) return null

  const shouldShowAll = isMobile || showAllDocuments || documents.length <= 3
  const displayedDocuments = shouldShowAll ? documents : documents.slice(0, 3)

  const toggleShowAllDocuments = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    setShowAllDocuments(!showAllDocuments)
  }

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('prefix')}>{formatMessage({ id: 'CourtCases.Documents.Prefix' })}:</div>
        <DownloadAllDocumentsButton
          className={b('download-button', { mobile: true })}
          documents={documents}
        />
      </div>
      <div className={b('labels')}>
        {displayedDocuments.map((document) => {
          return (
            <DocumentLabel
              key={document!.id}
              filename={document!.name}
              fileUrl={document.fileUrl}
            />
          )
        })}
        {!shouldShowAll && <DocumentLabel key='ellipsis' filename='...' fileUrl='' />}
      </div>
      {!isMobile && documents.length > 3 && (
        <a
          href=''
          className={b('download-button', { desktop: true })}
          onClick={toggleShowAllDocuments}
        >
          {formatMessage({
            id: showAllDocuments
              ? 'CourtCases.Documents.ShowLessDocuments'
              : 'CourtCases.Documents.ShowAllDocuments'
          })}
        </a>
      )}
      <DownloadAllDocumentsButton
        className={b('download-button', { desktop: true })}
        documents={documents}
      />
    </div>
  )
}
